function resize() {

    console.log('lifecycle :', 'resize demo scene');
}

export {resize};
